import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import suiTheme from '@splashthat/sui/lib/theme';

const StyledTooltip = styled.div`
    position: relative;
`;
const StyledTooltipMain = styled.div`
    z-index: 10000;
    position: absolute;
    bottom: -10%;
    right: 20%;
    width: 90%;
    height: 130%;
    padding: 5px 20px;
    background-color: ${suiTheme.palette.grayscale.black};
    color: ${suiTheme.palette.grayscale.white};
    border-radius: 4px;
`;
const StyledTooltipArrow = styled.div`
    position: absolute;
    top: 50%;
    right: -6px;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-left: 6px solid ${suiTheme.palette.grayscale.black};
`;

export const Tooltip = (props) => {
    const [isHovered, setIsHovered] = useState(false);
    return (
        <StyledTooltip onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
            {props.element}
            {!!props.label && isHovered && props.enabled && (
                <StyledTooltipMain>
                    {props.label}
                    <StyledTooltipArrow />
                </StyledTooltipMain>
            )}
        </StyledTooltip>
    );
};

Tooltip.propTypes = {
    element: PropTypes.element.isRequired,
    enabled: PropTypes.bool,
    label: PropTypes.string,
};

Tooltip.defaultProps = {
    enabled: false,
    label: '',
};
